import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import {CircularProgress, Backdrop} from '@ui';
import {createForm, renderModalError} from '@utils/forms';
import {routes} from '@constants/routes';
import {showModal} from '@utils/modal';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import useQueryCustom from '@utils/hooks/useQueryCustom';

import EditUserResourcesForm from '../forms/EditUserResourcesForm';
import EditUserResourcesModel from '../forms/EditUserResourcesModel';
import {GetUserResourcesData} from '../../../graphql/user/query.graphql';

const EditUserResources = ({
    match: {
        params: {
            id,
        },
    },
}) => {
    const {
        loading: areDataLoading = true,
        data = {},
    } = useQueryCustom({
        query: GetUserResourcesData,
        options: {
            variables: {id: id}
        }
    });

    if (areDataLoading) {
        return (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        )
    }

    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('User', routes.users.index.path),
        });
    }

    const renderForm = () => {
        const model = EditUserResourcesModel(data, id),
            Form = createForm(
                () => model,
                EditUserResourcesForm,
                {entityId: convertToInt(id), id: convertToInt(id)}
            )

        return <Form/>;
    }

    return renderForm();
}

EditUserResources.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    }),
};

export default withRouter(EditUserResources);
